import { IPrintFileJobsQueryParams } from '../../../api/printFileJobs';

export const DEFAULT_PRINT_FILE_JOBS_PARAMS = (): IPrintFileJobsQueryParams => ({
    page: 1,
    limit: 20,
    sortDirection: 'DESC',
    total: 0,
});
